if (!customElements.get('gcs-material-preview')) {
  customElements.define('gcs-material-preview', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      const dialog = this.querySelector('dialog');
      const track = dialog.querySelector('[data-slides]');
      const controls = dialog.querySelector('[data-gallery-controls]');
      const count = dialog.querySelector('[data-gallery-count]');
      let timer, slides = [], session = 0, interacted = false;
      const stop = () => { clearTimeout(timer); interacted = true; };
      const index = () => Math.round(track.scrollLeft / (track.clientWidth || 1));
      const go = (direction) => {
        stop();
        const next = (index() + direction + slides.length) % slides.length;
        track.scrollTo({ left: next * track.clientWidth, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth' });
      };
      this.addEventListener('click', async (event) => {
        const link = event.target.closest('[data-material-preview]');
        if (!link || event.ctrlKey || event.metaKey || event.shiftKey || event.altKey) return;
        event.preventDefault();
        stop();
        interacted = false;
        const token = ++session;
        track.replaceChildren();
        const addSlide = (src, mobile, label) => {
          const picture = document.createElement('picture');
          if (mobile) {
            const source = document.createElement('source');
            source.media = '(max-width: 749px)';
            source.srcset = mobile;
            picture.append(source);
          }
          const image = document.createElement('img');
          image.width = 1536;
          image.height = 1024;
          image.alt = link.dataset.finish + ' ' + label;
          image.draggable = false;
          picture.append(image);
          track.append(picture);
          image.src = src;
          return image;
        };
        slides = [addSlide(link.href, '', 'living room rendering')];
        if (link.dataset.kitchen) slides.push(addSlide(link.dataset.kitchen, link.dataset.kitchenMobile, 'kitchen rendering'));
        controls.hidden = slides.length < 2;
        count.textContent = '1 / ' + slides.length;
        dialog.setAttribute('aria-label', link.dataset.finish + ' rendering gallery');
        dialog.showModal();
        track.scrollTo({ left: 0, behavior: 'instant' });
        await slides[0].decode().catch(() => {});
        if (token === session && dialog.open && slides.length > 1 && !interacted) timer = setTimeout(() => go(1), 3000);
      });
      dialog.querySelector('[data-previous]').addEventListener('click', () => go(-1));
      dialog.querySelector('[data-next]').addEventListener('click', () => go(1));
      dialog.querySelector('.gcs-material-preview__close').addEventListener('click', () => dialog.close());
      dialog.addEventListener('close', () => { stop(); session++; });
      dialog.addEventListener('click', (event) => { if (event.target === dialog) dialog.close(); });
      dialog.addEventListener('keydown', (event) => {
        if (slides.length > 1 && ['ArrowLeft', 'ArrowRight'].includes(event.key)) {
          event.preventDefault(); go(event.key === 'ArrowRight' ? 1 : -1);
        }
      });
      track.addEventListener('pointerdown', stop);
      track.addEventListener('wheel', stop, { passive: true });
      track.addEventListener('scroll', () => { count.textContent = (index() + 1) + ' / ' + slides.length; }, { passive: true });
      this.cleanup = () => { stop(); session++; };
    }
    disconnectedCallback() { this.cleanup?.(); }
  });
}
